export default {
  name: 'CarbonDirectionLoopLeft'
};